import React, { useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import db from "./Firebase";

const BulkCheckActivity = () => {
    const phoneNumbers = [
        "6200845477",
        "6201267920",
        "6201943098",
        "6201982223",
        "6202492823",
        "6203171192",
        "6204234158",
        "6204250539",
        "6204661386",
        "6204719981",
        "6205352342",
        "6205499211",
        "6205562212",
        "6206116303",
        "6206612051",
        "6206915839",
        "6206980981",
        "6207283554",
        "6207542120",
        "6265385293",
        "6287371015",
        "6299269184",
        "6299390783",
        "6299658254",
        "6299856895",
        "6299896571",
        "6306190464",
        "6306323907",
        "6307635712",
        "6307891865",
        "6307992062",
        "6363025562",
        "6386057898",
        "6386738540",
        "6386821389",
        "6387744397",
        "6387919343",
        "6387929687",
        "6388015527",
        "6390233059",
        "6390735548",
        "6391234923",
        "6392615254",
        "6392872141",
        "6392981176",
        "6393400918",
        "6393691001",
        "6393781013",
        "6394330534",
        "6394556300",
        "6394558600",
        "7004855911",
        "7007459189",
        "7007795372",
        "7033715594",
        "7050403956",
        "7050636013",
        "7050665664",
        "7050846607",
        "7052217617",
        "7052320680",
        "7054599145",
        "7061059013",
        "7061478213",
        "7070111525",
        "7071440911",
        "7080303317",
        "7091651717",
        "7091998194",
        "7208286498",
        "7209121830",
        "7209138468",
        "7209888389",
        "7256906083",
        "7261047229",
        "7266976992",
        "7273054395",
        "7275731213",
        "7277848248",
        "7294968639",
        "7296027356",
        "7301496855",
        "7307098392",
        "7307326346",
        "7309390844",
        "7317002829",
        "7319753426",
        "7320993188",
        "7320993685",
        "7322034628",
        "7352802133",
        "7355441732",
        "7355565575",
        "7355741495",
        "7362857006",
        "7365210551",
        "7366931138",
        "7367038015",
        "7370953470",
        "7379534589",
        "7379712889",
        "7380480088",
        "7388410782",
        "7388705615",
        "7388905439",
        "7394944077",
        "7398255479",
        "7398638736",
        "7399122444",
        "7459916818",
        "7463800924",
        "7463824093",
        "7484968528",
        "7485840280",
        "7491823266",
        "7493804850",
        "7499110645",
        "7505950713",
        "7524044143",
        "7541901416",
        "7541902804",
        "7542014489",
        "7542963320",
        "7564081359",
        "7607043550",
        "7607208688",
        "7632883725",
        "7634069124",
        "7652029392",
        "7667070835",
        "7667573688",
        "7668222596",
        "7739068900",
        "7739384744",
        "7739719002",
        "7752858270",
        "7753968356",
        "7759946366",
        "7761046673",
        "7765872693",
        "7766067161",
        "7766800505",
        "7781075625",
        "7781854614",
        "7783005953",
        "7783898988",
        "7800488019",
        "7808093767",
        "7839193876",
        "7839755913",
        "7844006244",
        "7857005135",
        "7870825746",
        "7880608518",
        "7880927287",
        "7903564223",
        "7903590083",
        "7903868264",
        "790538800",
        "7924805448",
        "7970353774",
        "7985034077",
        "7985961308",
        "8002000314",
        "8002007131",
        "8002016924",
        "8002341596",
        "8002526640",
        "8002835482",
        "8005427228",
        "8005427728",
        "8009430411",
        "8052266976",
        "8063655812",
        "8078503502",
        "8081648212",
        "8081880943",
        "808347604",
        "8083477604",
        "8084318941",
        "8090108815",
        "8090992025",
        "8091702138",
        "8092785932",
        "8100543721",
        "8112539634",
        "8115096076",
        "8115158961",
        "8115692881",
        "8127774639",
        "8160012494",
        "8174934115",
        "8176851069",
        "8188941211",
        "8210909499",
        "8222092630",
        "8228987158",
        "8235824593",
        "8271149450",
        "8284173340",
        "8292206933",
        "8292565626",
        "8294910304",
        "8299475067",
        "8303844116",
        "8317081027",
        "8318155277",
        "8318729370",
        "8318868619",
        "8340576011",
        "8354871662",
        "8354961070",
        "8381890254",
        "8400911259",
        "8409186303",
        "8409729484",
        "8423321477",
        "8423550704",
        "8423562063",
        "8423597861",
        "8429615131",
        "8429854178",
        "8433312532",
        "8433392851",
        "8434267221",
        "8507544607",
        "8507889598",
        "8521042010",
        "8521317506",
        "8521519841",
        "8528685476",
        "8539011948",
        "8565060465",
        "8584890415",
        "8601516566",
        "8601962864",
        "8655185568",
        "8707220033",
        "8709231629",
        "8709241305",
        "8736851338",
        "8736943430",
        "8737046996",
        "8737860510",
        "8757271909",
        "8757606797",
        "8789911099",
        "8795161420",
        "8797192674",
        "8804302684",
        "8809202600",
        "8809690541",
        "8825331226",
        "8827419902",
        "8839755676",
        "8840236653",
        "8840908360",
        "8840919509",
        "8853491531",
        "8858234876",
        "8858759014",
        "8858796432",
        "8863857456",
        "8863886155",
        "8887756347",
        "8896822494",
        "8922089420",
        "8931005313",
        "8957611212",
        "8957693234",
        "8957785202",
        "8960152479",
        "8960521007",
        "8960878831",
        "8960914942",
        "8986377734",
        "8987038556",
        "9005127911",
        "9006650131",
        "9006861570",
        "9006897389",
        "9006935778",
        "9026058351",
        "90261640970",
        "9026183441",
        "9026308114",
        "9026843573",
        "9026889076",
        "9026944781",
        "9031539855",
        "9031542170",
        "9057738026",
        "9060907898",
        "9076934175",
        "9097584711",
        "9102219993",
        "9102362193",
        "9102565133",
        "9110039928",
        "9117436320",
        "9118386840",
        "9118437633",
        "9119914024",
        "9121316272",
        "9122880773",
        "9129161502",
        "9135027284",
        "9135466109",
        "9142248359",
        "9151215434",
        "9153125218",
        "9155580165",
        "9155781403",
        "9161568622",
        "9162048193",
        "9162394657",
        "9162844471",
        "9162969826",
        "9170204824",
        "9170746502",
        "9204813943",
        "9214175581",
        "9219018258",
        "9219424346",
        "9219986121",
        "9234181903",
        "9234746038",
        "9235309741",
        "9235323364",
        "9235346406",
        "9235417392",
        "9235494932",
        "9235523876",
        "9235904358",
        "9236013493",
        "9236583732",
        "9236670594",
        "9241715634",
        "9250004608",
        "9250223328",
        "9250305844",
        "9263794505",
        "9263857015",
        "9279836826",
        "9304112878",
        "9305485716",
        "9305833971",
        "9305907536",
        "9334740557",
        "9334872281",
        "9335193275",
        "9336139024",
        "9336153552",
        "9336674839",
        "9336869549",
        "933693167",
        "9369093263",
        "9369258719",
        "9369338405",
        "9415293789",
        "9451098981",
        "9451868470",
        "9451906939",
        "9454850265",
        "9455066348",
        "9472664838",
        "9504648758",
        "9506238945",
        "9508970425",
        "9519217260",
        "9523215665",
        "9523930723",
        "9525913937",
        "9532072861",
        "9546064494",
        "9546092344",
        "9546953485",
        "9555379627",
        "9555450394",
        "9555695040",
        "9559208721",
        "9559884950",
        "9569104014",
        "9569595057",
        "9570548096",
        "9572569931",
        "9576557691",
        "9576581326",
        "9580206344",
        "9580217020",
        "9598367591",
        "9608151847",
        "9621091362",
        "9621673442",
        "9648095920",
        "9651578948",
        "9651894090",
        "9659722965",
        "9661217180",
        "9661271501",
        "9661409581",
        "9661435034",
        "9661826918",
        "9661928073",
        "9682443326",
        "9682489417",
        "9693040347",
        "9693464594",
        "9693630945",
        "9693630947",
        "9693664423",
        "9695113238",
        "9695327918",
        "9695801260",
        "9696140705",
        "9696565945",
        "9698038645",
        "9708772859",
        "9716353654",
        "9771562203",
        "9792413244",
        "9793699940",
        "9794134278",
        "9794500978",
        "9794771413",
        "9798323277",
        "9798760054",
        "9801140433",
        "9801204610",
        "9807142851",
        "9807405228",
        "9818119406",
        "9819099195",
        "9852029028",
        "9852249827",
        "9852280356",
        "9889142585",
        "9896119783",
        "9899380590",
        "9931289834",
        "9931441230",
        "9931892783",
        "9934035976",
        "9936479348",
        "9936685807",
        "9939533776",
        "9939608104",
        "9939666972",
        "9955321311",
        "9956168009",
        "9973011676",
        "9973203172",
    ];

    const [results, setResults] = useState([]);
    const [foundCount, setFoundCount] = useState(0);
    const [notFoundCount, setNotFoundCount] = useState(0);
    const [checking, setChecking] = useState(false);

    const handleCheck = async () => {
        setChecking(true);

        // 🔄 Remove duplicates first
        const uniquePhones = Array.from(new Set(phoneNumbers));

        // ✅ Load all document IDs (phone numbers)
        const allDocsSnap = await getDocs(collection(db, "users_activity"));
        const phoneSet = new Set();

        allDocsSnap.forEach((docSnap) => {
            phoneSet.add(docSnap.id.trim()); // ✅ Use doc ID as phone
        });

        // 🚀 Compare
        const mappedResults = uniquePhones.map((phone, index) => {
            const status = phoneSet.has(phone) ? "Found Download" : "Not Found";
            return {
                sr: index + 1,
                phone,
                status
            };
        });

        const totalFound = mappedResults.filter(r => r.status === "Found Download").length;
        const totalNotFound = mappedResults.length - totalFound;

        setResults(mappedResults);
        setFoundCount(totalFound);
        setNotFoundCount(totalNotFound);
        setChecking(false);
    };


    return (
        <div className="container p-4">
            <h4>🔍 Fast Bulk Check in <code>users_activity</code></h4>

            <button
                className="btn btn-primary mb-3 mt-3"
                onClick={handleCheck}
                disabled={checking}
            >
                {checking ? "Checking..." : "🚀 Start Fast Check"}
            </button>

            {(results.length > 0 || checking) && (
                <div className="mb-3">
                    <strong>Total:</strong> {results.length} |{" "}
                    <span className="text-success">✅ Found Download: {foundCount}</span> |{" "}
                    <span className="text-danger">❌ Not Found: {notFoundCount}</span>
                </div>
            )}

            {results.length > 0 && (
                <table className="table table-bordered table-sm">
                    <thead>
                        <tr>
                            <th>Sr. No</th>
                            <th>Phone No</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {results.map((row) => (
                            <tr key={row.phone}>
                                <td>{row.sr}</td>
                                <td>{row.phone}</td>
                                <td>
                                    <span
                                        className={
                                            row.status === "Found Download" ? "text-success" : "text-danger"
                                        }
                                    >
                                        {row.status}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}

            {results.length === 0 && !checking && (
                <p>No data checked yet. Click "Start Fast Check" above 👆</p>
            )}
        </div>
    );
};

export default BulkCheckActivity;
